import React from 'react';
import { useTranslation } from 'react-i18next';
import './Landing.css';
import Header from './Header';
import { SparklesIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { LANGUAGE } from '../i18n';

const Landing = () => {
  const { t } = useTranslation();

  return (
    <div className="Landing__container">
      <Header />

        <section className="Landing__hero">
          <div className="Landing__content-container">
            <div className="Landing__hero-content">
              <h1>{t('landing.heroTitle')}</h1>
              <p>{t('landing.heroSubtitle')}</p>
              <a href="/auth" className="Landing__cta-button">{t('landing.ctaStart')}</a>
            </div>
            <div className="Landing__hero-image">
              <svg
                className="Landing__hero-svg"
                width="380"
                height="290"
                viewBox="0 0 420 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <filter id="cardShadow" x="-30%" y="-30%" width="160%" height="160%">
                    <feDropShadow dx="0" dy="8" stdDeviation="8" floodColor="rgba(0, 0, 0, 0.15)" />
                  </filter>
                </defs>

                {/* Фон карточки */}
                <rect
                  x="20"
                  y="20"
                  width="380"
                  height="290"
                  rx="24"
                  fill="#ffffff"
                  filter="url(#cardShadow)"
                />

                {/* Вертикальная разделительная линия */}
                <line x1="210" y1="60" x2="210" y2="270" stroke="#c7d8ff" strokeWidth="2" />

                {/* Заголовки */}
                <text
                  x="115"
                  y="80"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#b0bec5"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  {t('landing.svgLegal1')}
                </text>
                <text
                  x="115"
                  y="105"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#b0bec5"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  {t('landing.svgLegal2')}
                </text>

                <text
                  x="305"
                  y="80"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#7a9cc6"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  {t('landing.svgHuman1')}
                </text>
                <text
                  x="305"
                  y="105"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#7a9cc6"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  {t('landing.svgHuman2')}
                </text>

                {/* Левые полосы */}
                <rect x="55" y="140" width="120" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="175" width="120" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="210" width="100" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="245" width="80" height="20" rx="10" fill="#b0bec5" />

                {/* Правые полосы */}
                <rect x="245" y="140" width="120" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="175" width="100" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="210" width="120" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="245" width="80" height="20" rx="10" fill="#a3c8ff" />
              </svg>
            </div>
          </div>
        </section>

        <section className="Landing__features">
          <div className="Landing__content-container">
            <h2>{t('landing.featuresTitle')}</h2>
            <div className="Landing__features-grid">
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2196F3" width="32" height="32">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                  </svg>
                </div>
                <h3>{t('landing.feature1Title')}</h3>
                <p>{t('landing.feature1Desc')}</p>
              </div>
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <SparklesIcon width={32} height={32} style={{ color: '#2196F3' }} />
                </div>
                <h3>{t('landing.feature2Title')}</h3>
                <p>{t('landing.feature2Desc')}</p>
              </div>
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2196F3" width="32" height="32">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                </div>
                <h3>{t('landing.feature3Title')}</h3>
                <p>{t('landing.feature3Desc')}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="Landing__example">
          <div className="Landing__content-container">
            <h2>{t('landing.exampleTitle')}</h2>
            <p className="Landing__example-description">{t('landing.exampleDesc')}</p>
            <div className="Landing__dual-list">
              {/* Пункт 1 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>{t('landing.example1Left')}</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>{t('landing.example1Right')}</p>
                </div>
              </div>

              {/* Пункт 2 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>{t('landing.example2Left')}</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>{t('landing.example2Right')}</p>
                </div>
              </div>

              {/* Пункт 3 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>{t('landing.example3Left')}</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>{t('landing.example3Right')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="Landing__key-points">
          <div className="Landing__content-container">
            <h2>{t('landing.keyPointsTitle')}</h2>
            <p className="Landing__key-points-description">{t('landing.keyPointsDesc')}</p>

            <div className="Landing__key-points-container">
              <div className="Landing__key-point-card">
                <h3>{t('landing.kp1Title')}</h3>
                <p>{t('landing.kp1Desc')}</p>
              </div>

              <div className="Landing__key-point-card">
                <h3>{t('landing.kp2Title')}</h3>
                <p>{t('landing.kp2Desc')}</p>
              </div>

              <div className="Landing__key-point-card">
                <h3>{t('landing.kp3Title')}</h3>
                <p>{t('landing.kp3Desc')}</p>
              </div>

              <div className="Landing__key-point-card">
                <h3>{t('landing.kp4Title')}</h3>
                <p>{t('landing.kp4Desc1')}<br/>
                {t('landing.kp4Desc2')}</p>
              </div>

              <div className="Landing__key-point-card">
                <h3>{t('landing.kp5Title')}</h3>
                <p>{t('landing.kp5Desc')}</p>
              </div>

              <div className="Landing__key-point-card">
                <h3>{t('landing.kp6Title')}</h3>
                <p>{t('landing.kp6Desc')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* === QA Section: Answers to document questions === */}
        <section className="Landing__qa">
          <div className="Landing__content-container">
            <h2>{t('landing.qaTitle')}</h2>
            <p className="Landing__qa-description">{t('landing.qaDesc')}</p>

            <div className="Landing__chat-container">
              <div className="Landing__chat-message user">
                <p>{t('landing.qaQuestion')}</p>
              </div>
              <div className="Landing__chat-message ai">
                <p>{t('landing.qaAnswer')}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="Landing__translation">
          <div className="Landing__content-container">
            <h2>{t('landing.translationTitle')}</h2>
            <p className="Landing__translation-description">{t('landing.translationDesc')}</p>

            <div className="Landing__example-container three-columns">
              <div className="Landing__example-item">
                <h3>{t('landing.translationOrigLabel')}</h3>
                <div className="Landing__example-card original">
                  <p>{t('landing.translationOrigText')}</p>
                </div>
              </div>
              <div className="Landing__example-arrow">
                <div className="Landing__arrow-icon"></div>
              </div>
              <div className="Landing__example-item">
                <h3>{t('landing.translationLabel')}</h3>
                <div className="Landing__example-card translation">
                  <p>{t('landing.translationText')}</p>
                </div>
              </div>
              <div className="Landing__example-arrow">
                <div className="Landing__arrow-icon"></div>
              </div>
              <div className="Landing__example-item">
                <h3>{t('landing.translationSimplifiedLabel')}</h3>
                <div className="Landing__example-card simplified">
                  <p>{t('landing.translationSimplifiedText')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="Landing__cta-section">
          <div className="Landing__content-container">
            <h2>{t('landing.ctaTitle')}</h2>
            <p className="Landing__cta-description">{t('landing.ctaDesc')}</p>
            <a href="/auth" className="Landing__cta-button-large">{t('landing.ctaTryFree')}</a>
          </div>
        </section>

        {LANGUAGE === 'ru' && (
          <footer className="Landing__footer">
            <div className="Landing__content-container">
              <a href="/terms" className="Landing__footer-link">{t('landing.footerTerms')}</a>
            </div>
          </footer>
        )}
    </div>
  );
};

export default Landing;

